import apiClient from '@utils/apiClient';

export const bbsOptimise = (payload) => {
  return apiClient.post(`${apiClient.Urls.bbsOptimise}`, payload, true, 'file');
};

export const bbsAlgorithm = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.bbsAlgorithm}`,
    payload,
    true,
    'file',
  );
};

export const bbsViewFiles = (params) => {
  const queryString = Object.keys(params)
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`,
    )
    .join('&');
  return apiClient.get(`${apiClient.Urls.bbsViewFiles}?${queryString}`, true);
};

export const finalSummary = (params) => {
  const queryString = Object.keys(params)
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`,
    )
    .join('&');
  return apiClient.get(`${apiClient.Urls.finalSummary}?${queryString}`, true);
};
